import React from 'react';

type Props = {color?: string};

export const BraceletTabSvg: React.FC<Props> = ({color = '#FF8A71'}) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={50} height={24} fill='none'>
    <circle cx='25' cy='12' r='3' fill={color}/>
    <path
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      fill='none'
      d='M19.5 7.5a8 8 0 0 1 11 0M21 9a6 6 0 0 1 8 0M29 15a6 6 0 0 1-8 0M30.5 16.5a8 8 0 0 1-11 0'
    />
  </svg>
);
